import { mountMahjong } from '../render/three/game-app.js';
import { makePyramidSpec } from '../variants/mahjong-solitaire/spec.js';

mountMahjong(makePyramidSpec()).catch((err) => {
  console.error('failed to mount mahjong pyramid', err);
});
